/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from './useFormUtils'
import Switch from 'react-switch'
import InputMask from 'react-input-mask'

const ReviewTwoFollowUp = ({ item, isDisabled }) => {
  const [packaging] = useState({
    EffectiveDate: item?.EffectiveDate,
    ReviewTwoFollowUp: item?.ReviewTwoFollowUp,
  })
  const methods = useFormContext()
  const { onChangeReviewer, setSwitchReviewer } = useFormUtils()
  const currentDate = new Date()
  const today =
    currentDate.getFullYear() +
    '-' +
    ('0' + (currentDate.getMonth() + 1)).slice(-2) +
    '-' +
    ('0' + currentDate.getDate()).slice(-2)

  const getDateOnly = EffectiveDate => {
    if (!EffectiveDate) {
      return null
    }

    const date = new Date(EffectiveDate)
    const dateOnly =
      date.getFullYear() +
      '-' +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + date.getDate()).slice(-2)

    return dateOnly
  }

  return (
    <Row>
      <Col xs={3}>
        <FormGroup>
          <p>
            <strong>EBT Effective Date</strong>
          </p>
          <Controller
            as={Input}
            type="date"
            min={today}
            tag={InputMask}
            name="EffectiveDate"
            defaultValue={getDateOnly(packaging.EffectiveDate)}
            control={methods.control}
            onChange={([event]) => {
              onChangeReviewer(item, event)
              return event
            }}
            disabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="EffectiveDate"
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
      {!isDisabled && (
        <Col xs={3}>
          <p>
            <strong>EBT TBD</strong>
          </p>
          <Controller
            as={Switch}
            name="ReviewTwoFollowUp"
            id="ReviewTwoFollowUp"
            defaultValue={packaging.ReviewTwoFollowUp}
            onChange={([checked, event, id]) => {
              setSwitchReviewer(item, checked, event, id)
              return checked
            }}
            control={methods.control}
            checked={packaging.ReviewTwoFollowUp}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="ReviewTwoFollowUp"
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </Col>
      )}
    </Row>
  )
}

export default ReviewTwoFollowUp
